import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from './constants';
import { BetModel } from '../models/BetModel';

@Injectable({
  providedIn: 'root'
})
export class BetsService {
  serviceURL = "/v1/Bet/";
  token: string = localStorage.getItem('token');

  constructor(private http: HttpClient) { }

  postBet(model: BetModel){
    const url = Constants.baseURL + this.serviceURL + 'PlaceBet';

    return this.http.post(url, model);
  }

  postBetSlip(data){
    const url = Constants.baseURL + this.serviceURL + 'ProcessBetSlip';

    return this.http.post(url, data);
  }

  getBetForWar(warId: String, entryId:Number){
    // const url = Constants.baseURL + this.serviceURL + 'GetWarBets?warId=' + warId;
    console.log('warid',warId,'entryid', entryId)
    const url = Constants.baseURL + this.serviceURL +  `GetWarBets?WarID=${warId}&EntryID=${entryId}`;
    return this.http.get(url);
  }
  getParlayForWar(warId: String){
    const url = Constants.baseURL + this.serviceURL + 'GetWarParlays?warId=' + warId;

    return this.http.get(url);
  }

  getBet(){
    const url = Constants.baseURL + this.serviceURL + 'GetMyBets';

    return this.http.get(url);
  }

  getAccountSnapshot(){
    const url = Constants.baseURL + this.serviceURL + 'GetAccountSnapshot';

    return this.http.get(url);
  }

  getTransactionSnapshot(){
    const url = Constants.baseURL + this.serviceURL + 'GetTransactionSnapshot';

    return this.http.get(url);
  }

  getTransactionswithToken(page){
    const url = `${Constants.baseURL}/v1/Generic/GetTransactionWithToken?Token=${this.token}&Page=${page}`;

    return this.http.get(url);
  }

  getUserWarBets(warId: string, userId:string){
    const url = Constants.baseURL + this.serviceURL + 'GetUserWarBets?warId='+warId+'&userId='+userId;

    return this.http.get(url);
  }

  getAccountSnapshotwithToken(){
    const url = `${Constants.baseURL}/v1/Generic/GetAccountSnapshotWithToken?Token=${this.token}`;

    return this.http.get(url);
  }

}
